export function getTargetSectionFromState(state: string | null): string {
    if (!state) {
        return '';
    }

    const stateTokens = decodeURIComponent(state).split('||');

    if (stateTokens.length < 1) {
        return '';
    }

    return stateTokens[0];
}
